import { Link } from '@joehua/react-link';
import * as React from 'react';
import { themr } from 'react-css-themr';
import EntityImage from '../EntityImage';
export const defaultEntityCardTheme = {
    root: 'bb b--light-gray flex flex-wrap pa2',
    imageWrapper: 'w-100 w-30-ns',
    image: 'w-100',
    contentWrapper: 'w-100 w-70-ns pv2 ph3',
    titleText: 'f5 f4-ns fw7',
    description: 'f6 f5-ns mid-gray fw4',
    readMore: 'pt3 pointer',
    readMoreText: 'f6 f5-ns blue',
};
const DumpEntityCard = ({ entity, route, renderMeta, showImage = true, showDescription, readMore = 'Xem thêm →', theme = {}, }) => {
    const to = { name: route, params: { slug: entity.slug } };
    return (React.createElement("div", { className: theme.root },
        showImage && (React.createElement("div", { className: theme.imageWrapper },
            React.createElement(Link, { to: to },
                React.createElement(EntityImage, { className: theme.image, entity: entity })))),
        React.createElement("div", { className: theme.contentWrapper },
            React.createElement(Link, { className: theme.title, to: to },
                React.createElement("h3", { className: theme.titleText }, entity.title)),
            renderMeta && (React.createElement("div", { className: theme.meta }, renderMeta({ entity }))),
            showDescription && (React.createElement("div", { className: theme.description }, entity.description)),
            readMore && (React.createElement(Link, { className: theme.readMore, to: to },
                React.createElement("span", { className: theme.readMoreText }, readMore))))));
};
const EntityCard = themr('EntityCard', {}, {
    composeTheme: 'softly',
})(DumpEntityCard);
export default EntityCard;
//# sourceMappingURL=index.js.map